import React from "react";
import { useLocation } from "react-router-dom";

class ErrorBoundary extends React.Component {

    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Eroare neasteptata:", error, errorInfo);
    }

    componentDidUpdate(prevProps) {
        // la navigare resetam boundary-ul, ca eroarea de pe o pagina
        // sa nu blocheze si paginile urmatoare
        if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
            this.setState({ hasError: false });
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <>
                    <h2>A aparut o eroare</h2>
                    <div className="formular">
                        <fieldset>
                            <p className="paragraf">
                                Pagina nu a putut fi afisata. Incercati din nou sau selectati alta optiune din meniu.
                            </p>
                            <button className="btn" onClick={() => window.location.reload()}>Reincarca pagina</button>
                        </fieldset>
                    </div>
                </>
            );
        }

        return this.props.children;
    }
}

export const RouteErrorBoundary = (props) => {
    const location = useLocation();

    return (
        <ErrorBoundary resetKey={location.pathname + location.search}>
            {props.children}
        </ErrorBoundary>
    );
};
